import { useUserContext } from '../../Contexts/UserConfig'
import { useMessagePopupContext } from '../../garvan-react/Components/ModalFeedback/MessagePopup'
import { useQuery } from 'react-query'
import { AxiosResponse } from 'axios'
import ReportService from '../PHP/APIs/ReportService'
import {
  tsGetBPLitterReport,
  tsGetCullReport,
  tsGetOldLinesReport,
  tsGetWeaningReport,
} from '../../Typescript/API_Response'

export function useGetWeaningReport(holding_id: number) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<tsGetWeaningReport[], AxiosResponse>(
    ['ReportService', 'getWeaningReport', holding_id],
    () => ReportService.getWeaningReport(whoAmI!, holding_id),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!holding_id,
    },
  )
}

export function useGetCullReport(holding_id: number) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<tsGetCullReport[], AxiosResponse>(
    ['ReportService', 'getCullReport', holding_id],
    () => ReportService.getCullReport(whoAmI!, holding_id),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!holding_id,
    },
  )
}

export function useGetBPLitterReport(holding_id: number, litter_seq: number) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<tsGetBPLitterReport[], AxiosResponse>(
    ['ReportService', 'getCullReport', holding_id, litter_seq],
    () => ReportService.getBPLitterReport(whoAmI!, holding_id, litter_seq),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!holding_id && !!litter_seq,
    },
  )
}

export function useGetOldLinesReport(holding_id: number) {
  const { whoAmI } = useUserContext()
  const { setError } = useMessagePopupContext()
  return useQuery<tsGetOldLinesReport[], AxiosResponse>(
    ['ReportService', 'getCullReport', holding_id],
    () => ReportService.getOldLinesReport(whoAmI!, holding_id),
    {
      onError: (err) => setError(err),
      enabled: !!whoAmI && !!holding_id,
    },
  )
}
